import { render, staticRenderFns } from "./course_discuss.vue?vue&type=template&id=10883734&scoped=true&"
import script from "./course_discuss.vue?vue&type=script&lang=js&"
export * from "./course_discuss.vue?vue&type=script&lang=js&"
import style0 from "./course_discuss.vue?vue&type=style&index=0&id=10883734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10883734",
  null
  
)

export default component.exports